import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface Context {
  open: boolean
  currentPileHoleId: string | undefined
  setOpen: (open: boolean) => void
  setCurrentPileHoleId: (value: string | undefined) => void
}

export const PileExecutedStatusChangerContext = createContext<Context>({
  open: false,
  currentPileHoleId: undefined,
  setOpen: () => {},
  setCurrentPileHoleId: () => {},
})

export const PileExecutedStatusChangerContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [currentPileHoleId, setCurrentPileHoleId] = useState<string | undefined>(undefined)

  return (
    <PileExecutedStatusChangerContext.Provider
      value={{ open, currentPileHoleId, setOpen, setCurrentPileHoleId }}>
      {children}
    </PileExecutedStatusChangerContext.Provider>
  )
}
